module.exports = __webpack_public_path__ + "img/institutional-main.69b1dfbe.webp";